module.exports = __webpack_public_path__ + "static/img/logo_ico.30474694.svg";